interface ScrollPosition {
  scrollX: number
  scrollY: number
  offset: number
}

/** Состояние для восстановления позиции при возврате из страницы детали в список */
export interface DetailReturnState {
  itemId: string
  index: number
  offsetToLoad: number
  cardOffsetFromViewportTop: number
}

const useInfiniteScrollStore = defineStore('infiniteScroll', () => {
  const positions = ref<Record<string, ScrollPosition>>({})
  const containerClasses = ref<Record<string, string>>({})
  const detailReturn = ref<Record<string, DetailReturnState>>({})

  function savePosition(key: string, scrollX: number, scrollY: number, offset: number) {
    positions.value[key] = { scrollX, scrollY, offset }
  }

  function getPosition(key: string): ScrollPosition | undefined {
    return positions.value[key]
  }

  function clearPosition(key: string) {
    delete positions.value[key]
  }

  function clearAllPositions() {
    positions.value = {}
  }

  function setDetailReturnState(listKey: string, state: DetailReturnState) {
    detailReturn.value[listKey] = state
  }

  function getDetailReturnState(listKey: string): DetailReturnState | undefined {
    return detailReturn.value[listKey]
  }

  function clearDetailReturnState(listKey: string) {
    delete detailReturn.value[listKey]
  }

  function setContainerClass(key: string, className: string) {
    containerClasses.value[key] = className
  }

  function getContainerClass(key: string): string | undefined {
    return containerClasses.value[key]
  }

  function clearContainerClass(key: string) {
    delete containerClasses.value[key]
  }

  return {
    savePosition,
    getPosition,
    clearPosition,
    clearAllPositions,
    setDetailReturnState,
    getDetailReturnState,
    clearDetailReturnState,
    setContainerClass,
    getContainerClass,
    clearContainerClass,
  }
}, {
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
})

export default useInfiniteScrollStore
